import { type APIChannel, ChannelType } from '../contracts/chat-types.js';
import { PermissionFlags } from '../contracts/chat-permissions.js';

/** Canal que o @everyone não vê (o ícone ganha cadeado, como no Discord). */
export function canalPrivado(canal: APIChannel): boolean {
  if (!canal.guild_id) return false;
  const everyone = canal.permission_overwrites?.find(
    (item) => item.id === canal.guild_id,
  );
  if (!everyone) return false;
  try {
    return (BigInt(everyone.deny) & PermissionFlags.VIEW_CHANNEL) !== 0n;
  } catch {
    return false;
  }
}

/** Canais em que se entra para ler mensagens (texto, anúncio, voz antiga, thread). */
export function abreComoChat(canal: APIChannel): boolean {
  return (
    canal.type !== ChannelType.GUILD_CATEGORY &&
    canal.type !== ChannelType.GUILD_FORUM &&
    canal.type !== ChannelType.GUILD_MEDIA
  );
}
